import React from "react";
import ReactMarkdown from "react-markdown";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";

// Plugin arrays are stable references so React doesn't see new prop identities
// on every render — important during streamed token-by-token updates.
const REMARK_PLUGINS = [remarkMath];
const REHYPE_PLUGINS = [rehypeKatex];

interface MathMarkdownProps {
  children: string;
}

// Block-level Markdown renderer with LaTeX support via KaTeX.
// Use this for any rich text rendered through ReactMarkdown in the coaching
// surface (coach bubbles, feedback panels, rich_text blocks, wrap-up summaries).
export const MathMarkdown: React.FC<MathMarkdownProps> = ({ children }) => (
  <ReactMarkdown remarkPlugins={REMARK_PLUGINS} rehypePlugins={REHYPE_PLUGINS}>
    {children}
  </ReactMarkdown>
);

interface MathTextProps {
  text: string;
}

// Inline LaTeX-aware text renderer for short, single-line strings (option
// labels, quest titles, chip descriptions). Wraps in a span so the surrounding
// flex/button layout isn't broken by ReactMarkdown's default <p> wrapper.
export const MathText: React.FC<MathTextProps> = ({ text }) => (
  <span className="math-text">
    <ReactMarkdown
      remarkPlugins={REMARK_PLUGINS}
      rehypePlugins={REHYPE_PLUGINS}
      components={{
        p: ({ children }) => <>{children}</>,
      }}
    >
      {text}
    </ReactMarkdown>
  </span>
);
